export const ModeDictionary = Object.freeze({
	payment: 'payment',
	delivery: 'delivery',
	paymentDelivery: 'payment_delivery',
	terminalPayment: 'terminal_payment',
});
